<template>
  <transition name="fade-in">
    <div v-show="visible" class="overlay" :style="style" @click.stop="maskClick">
      <slot></slot>
    </div>
  </transition>
</template>

<script>
export default {
  model: {
    prop: 'visible',
    event: 'close',
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    lockScroll: {
      type: Boolean,
      default: true,
    },
    zIndex: {
      type: Number,
      default: 200,
    },
    backgroundColor: {
      type: String,
      default: 'rgba(0, 0, 0, .5)',
    },
    closeOnClickModal: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    style() {
      return {
        'z-index': this.zIndex,
        'background-color': this.backgroundColor,
      };
    },
  },
  watch: {
    visible: {
      handler(val) {
        this.$nextTick(() => {
          const body = document.querySelector('body');
          if (!this.lockScroll || !body.classList) return;
          if (val) {
            body.classList.add('no-scroll');
          } else {
            body.classList.remove('no-scroll');
          }
        });
      },
      immediate: true,
    },
  },
  methods: {
    maskClick() {
      this.$emit('click');
      this.closeOnClickModal && this.$emit('close', false);
    },
  },
};
</script>

<style>
.no-scroll {
  overflow: hidden;
}
</style>

<style lang="less" scoped>
.overlay {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}
</style>
